<template>
    <vx-card title="Служебные параметры Cpm Coefficient Calculator" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Дни"
                        v-model="form.cpmCoeffCalcAgeDays"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.cpmCoeffCalcAgeDays"
                        :danger-text="errors.cpmCoeffCalcAgeDays"
                    />
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                 <vs-input
                        label="Список SSP Id через запятую."
                        v-model="form.cpmCoeffCalcSSPIDs"
                        class="mt-1 w-full"
                        :danger="!!errors.cpmCoeffCalcSSPIDs"
                        :danger-text="errors.cpmCoeffCalcSSPIDs"
                    />
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Порог кликов"
                        v-model="form.cpmCoeffCalcClicksThreshold"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.cpmCoeffCalcClicksThreshold"
                        :danger-text="errors.cpmCoeffCalcClicksThreshold"
                    />
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Порог показов"
                        v-model="form.cpmCoeffCalcBuyoutThreshold"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.cpmCoeffCalcBuyoutThreshold"
                        :danger-text="errors.cpmCoeffCalcBuyoutThreshold"
                    />
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Порог показов для плохих объявлений"
                        v-model="form.cpmCoeffCalcBuyoutThrOldDays"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.cpmCoeffCalcBuyoutThrOldDays"
                        :danger-text="errors.cpmCoeffCalcBuyoutThrOldDays"
                    />
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Мин дней для плохих объвлений"
                        v-model="form.cpmCoeffCalcBuyoutOlderDays"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.cpmCoeffCalcBuyoutOlderDays"
                        :danger-text="errors.cpmCoeffCalcBuyoutOlderDays"
                    />
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Коэф по умолчании при недостачном количестве кликов"
                        v-model="form.cpmDefaultCoeffNotEnoughClicks"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.cpmDefaultCoeffNotEnoughClicks"
                        :danger-text="errors.cpmDefaultCoeffNotEnoughClicks"
                    />
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Минимальное количество кликов для определения начала расчета коефа блока"
                        v-model="form.cpmCoeffCalcDateMinClicks"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.cpmCoeffCalcDateMinClicks"
                        :danger-text="errors.cpmCoeffCalcDateMinClicks"
                    />
                </div>
            </div>
        </div>

        <vs-button class="mt-5 mr-2" color="success" @click="saveSettings()" type="filled"> Сохранить </vs-button>

        <vs-button class="mt-5" color="primary" @click="clearEdit()" type="filled"> Отменить </vs-button>
    </vx-card>
</template>

<script>
export default {
    data() {
        return {
            settings: undefined,
            form: {
                cpmCoeffCalcAgeDays : 0,
                cpmCoeffCalcSSPIDs  : 0,
                cpmCoeffCalcClicksThreshold  : 0,
                cpmCoeffCalcBuyoutThreshold : 0,
                cpmCoeffCalcBuyoutThrOldDays : 0,
                cpmCoeffCalcBuyoutOlderDays : 0,
                cpmDefaultCoeffNotEnoughClicks : 0,
                cpmCoeffCalcDateMinClicks : 0,
            },
            errors: {
                cpmCoeffCalcAgeDays: '',
                cpmCoeffCalcSSPIDs: '',
                cpmCoeffCalcClicksThreshold: '',
                cpmCoeffCalcBuyoutThreshold: '',
                cpmCoeffCalcBuyoutThrOldDays: '',
                cpmCoeffCalcBuyoutOlderDays: '',
                cpmDefaultCoeffNotEnoughClicks: '',
                cpmCoeffCalcDateMinClicks: '',              
            }
        };
    },
    mounted() {
        this.loadSettings();
    },
    methods: {
        loadSettings() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                method: 'GET',
                url: 'settings/cpm-coefficient-calculator',
                success: (settings) => {
                    this.settings = settings;
                    this.setSettings(settings);

                    this.$vs.loading.close('#loader > .con-vs-loading');
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка получения параметров!',
                        color: 'danger'
                    });
                }
            });
        },
        setSettings(settings) {
            this.form.cpmCoeffCalcAgeDays = settings.cpmCoeffCalcAgeDays;
            this.form.cpmCoeffCalcSSPIDs = settings.cpmCoeffCalcSSPIDs;
            this.form.cpmCoeffCalcClicksThreshold = settings.cpmCoeffCalcClicksThreshold;
            this.form.cpmCoeffCalcBuyoutThreshold = settings.cpmCoeffCalcBuyoutThreshold;
            this.form.cpmCoeffCalcBuyoutThrOldDays = settings.cpmCoeffCalcBuyoutThrOldDays;
            this.form.cpmCoeffCalcBuyoutOlderDays = settings.cpmCoeffCalcBuyoutOlderDays;
            this.form.cpmDefaultCoeffNotEnoughClicks = settings.cpmDefaultCoeffNotEnoughClicks;
            this.form.cpmCoeffCalcDateMinClicks = settings.cpmCoeffCalcDateMinClicks;
        },
        clearEdit() {
            this.setSettings(this.settings);
        },
        saveSettings() {
            let error = '';
            const interests = this.form.cpmCoeffCalcSSPIDs;

            const sspIds = this.form.cpmCoeffCalcSSPIDs;
            if (!sspIds) {
                error = 'Необходимо указать SSP через запятую.';
            }

            let sspIdsParsed = [];
            const sspIdsParts = sspIds.split(',').filter((i) => i != '');
            if (sspIdsParts && sspIdsParts.length > 0) {
                sspIdsParts.forEach((i) => {
                    if (!Number.isInteger(Number(i))) {
                        error = 'Введен некорректный список SSP.';
                    } else {
                        sspIdsParsed.push(i.trim());
                    }
                });
            }

            if (error) {
                return this.$vs.notify({
                    title: 'Внимание!',
                    text: error,
                    color: 'danger'
                });
            }            

            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                method: 'PUT',
                url: 'settings/cpm-coefficient-calculator',
                params: this.form,
                errors: this.errors,
                success: (response) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно обновлено',
                        text: 'Настройки успешно обновлены',
                        color: 'success'
                    });
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при сохранении настроек!',
                        color: 'danger'
                    });
                }
            });
        }
    },
    components: {}
};
</script>
